<template>
  <transition name="fade">
    <div v-if="accountStore.permissions" class="sidebar">
      <nav class="">
        <ul class="sidebar-menu">
          <div v-for="(nav, idx) in visibleSidebar" :key="idx">
            <li
              v-if="!noChildren && (!nav.perms || (accountStore && accountStore.permissions && (accountStore.permissions[nav.perms[0]] || accountStore.permissions[nav.perms[1]] )))"
              :class="{ 'active': name === nav.routeName || (name === 'co.v2.template' && nav.routeName === 'checkout.index') || nav.routeName === $route.query.redirect }"
              @click="handleClick(nav.route)"
            >
              <router-link
                :to="nav.route"
                class="nav-link"
                :style="{ borderLeftColor: (name === nav.routeName || (name === 'co.v2.template' && nav.routeName === 'checkout.index') || nav.routeName === $route.query.redirect ? nav.color : '') }"
              >
                <span
                  :class="{ 'active': name === nav.routeName || (name === 'co.v2.template' && nav.routeName === 'checkout.index') || nav.routeName === $route.query.redirect }"
                  @mouseover="sidebarHover"
                  @mouseleave="sidebarRemoveHover"
                >
                  <img
                    class="sidebar-menu-icon"
                    :src="`/static/img/icones/sidebar/${nav.imgFolder}/${name === nav.routeName || (name === 'co.v2.template' && nav.routeName === 'co.v2.template') || nav.routeName === $route.query.redirect ? 'active' : 'inactive'}.svg`"
                    alt=""
                  >
                  {{ nav.title }}
                </span>
              </router-link>
              <div v-if="nav.key === 'students' && nbStudentsToRate !== 0" class="bullet left-to-rate">
                {{ nbStudentsToRate }}
              </div>
              <div v-if="nav.key === 'validations' && nbStudentsToValidate !== 0" class="bullet left-to-validate">
                {{ nbStudentsToValidate }}
              </div>
              <div v-if="nav.key === 'quotes' && nbQuoteToValidate !== 0" class="bullet left-to-validate">
                {{ nbQuoteToValidate }}
              </div>
              <div v-if="nav.key === 'contracts' && nbContractsToSign !== 0" class="bullet left-to-validate">
                {{ nbContractsToSign }}
              </div>
            </li>
          </div>
          <div v-for="(nav, idx) in visibleSidebarForChildren" :key="idx">
            <li
              v-if="noChildren && (!nav.perms || (!nav.perms || (accountStore && accountStore.permissions && (accountStore.permissions[nav.perms[0]] || accountStore.permissions[nav.perms[1]])) ))"
              :class="[nav.imgFolder, { 'active': name === nav.routeName || (name === 'co.v2.template' && nav.routeName === 'checkout.index') || nav.routeName === $route.query.redirect }]"
              @click="handleClick(nav.route)"
            >
              <router-link
                :to="nav.route"
                class="nav-link"
                :style="{ borderLeftColor: (name === nav.routeName || (name === 'co.v2.template' && nav.routeName === 'checkout.index') ? nav.color : '') }"
              >
                <span
                  :class="{ 'active': name === nav.routeName || (name === 'co.v2.template' && nav.routeName === 'checkout.index') || nav.routeName === $route.query.redirect }"
                  @mouseover="sidebarHover"
                  @mouseleave="sidebarRemoveHover"
                  @click="handleBeforeNavigation"
                >
                  <img
                    class="sidebar-menu-icon"
                    :src="`/static/img/icones/sidebar/${nav.imgFolder}/${name === nav.routeName || (name === 'co.v2.template' && nav.routeName === 'co.v2.template') ? 'active' : 'inactive'}.svg`"
                    alt=""
                  >
                  {{ nav.title }}
                </span>
              </router-link>
              <div v-if="nav.key === 'students' && nbStudentsToRate !== 0" class="bullet left-to-rate">
                {{ nbStudentsToRate }}
              </div>
              <div v-if="nav.key === 'validations' && nbStudentsToValidate !== 0" class="bullet left-to-validate">
                {{ nbStudentsToValidate }}
              </div>
              <div v-if="nav.key === 'quotes' && nbQuoteToValidate !== 0" class="bullet left-to-validate">
                {{ nbQuoteToValidate }}
              </div>
              <div v-if="nav.key === 'contracts' && nbContractsToSign !== 0" class="bullet left-to-validate">
                {{ nbContractsToSign }}
              </div>

            </li>
          </div>
        </ul>
        <CustomerSupportBlockComponent/>
      </nav>
    </div>
  </transition>
</template>

<script>

import CustomerSupportBlockComponent from '@/components/CustomerSupport';
import DataService from '@/services/data/index';
import { mapStores } from 'pinia';
import { useAccountStore } from '@/stores/account';
import { useAuthStore } from '@/stores/auth';
import { useCartStore } from '@/stores/cart';
import { useCompanyStore } from '@/stores/company';
import { useCustomerKpiStore } from '@/stores/customerKpi';
import { useVideoPopupStore } from '@/stores/videoPopup';

export default {
  name: 'sidebar',
  components: {
    CustomerSupportBlockComponent,
  },
  props: ['name'],
  data() {
    return {
      route: null,
    };
  },
  computed: {
    ...mapStores(useAccountStore, useAuthStore, useCartStore, useCompanyStore, useCustomerKpiStore, useVideoPopupStore),
    // Source unique du menu : `sidebar` et `sidebarforchildren` en dérivent tous les deux.
    // `key` est un identifiant stable, découplé du libellé affiché — les pastilles s'y
    // réfèrent, pour qu'un changement de wording (SP-13660) ne les fasse pas disparaître.
    navItems() {
      return [{
        key: 'new-job',
        title: 'Nouvelle mission',
        color: '#ebc222',
        route: '/template',
        routeName: 'co.v2.template',
        imgFolder: 'proposition',
        perms: ['customerOrdersPlace', 'customerOrdersRequest'],
      }, {
        key: 'jobs',
        title: 'Mes missions',
        color: '#36bdbd',
        route: '/job',
        routeName: 'job.index',
        imgFolder: 'mesmissions',
      }, {
        key: 'validations',
        title: 'Mes validations',
        color: '#ebc222',
        route: '/validations',
        routeName: 'validations.index',
        imgFolder: 'validations',
        perms: ['customerValidateHours'],
      }, {
        key: 'contracts',
        title: 'Mes contrats',
        color: '#36bdbd',
        route: '/contrats',
        routeName: 'contrats.index',
        imgFolder: 'contrats',
        perms: ['customerContracts'],
      }, {
        key: 'students',
        title: this.$brand.isTempAgency ? 'Mes intérimaires' : 'Mes students',
        color: '#ebc222',
        route: '/students',
        routeName: 'students.index',
        imgFolder: 'profil',
      }, {
        key: 'invoices',
        title: 'Mes factures',
        color: '#ee5e6a',
        route: '/invoice',
        routeName: 'invoice.index',
        imgFolder: 'bill',
        perms: ['customerBillingInvoices'],
        // SP-13795 — invoicing is not handled in the customer area for temp agencies
        hideForTempAgency: true,
      }, {
        key: 'quotes',
        title: 'Mes devis',
        color: '#ee5e6a',
        route: '/quotes',
        routeName: 'quote.index',
        imgFolder: 'quote',
        perms: ['customerUserQuoteList'],
      }, {
        key: 'reporting',
        title: 'Mon reporting',
        color: '#36bdbd',
        route: '/data',
        routeName: 'data.index',
        imgFolder: 'reporting',
      }];
    },
    sidebar() {
      return this.navItems;
    },
    sidebarforchildren() {
      return this.navItems;
    },
    isTempAgencyMode() {
      return this.accountStore.isTempAgencyMode;
    },
    // SP-13795 — entries flagged `hideForTempAgency` disappear for temp agency companies.
    // Filtering here keeps the (already dense) permission `v-if` untouched.
    visibleSidebar() {
      return this.sidebar.filter((nav) => !(nav.hideForTempAgency && this.isTempAgencyMode));
    },
    visibleSidebarForChildren() {
      return this.sidebarforchildren.filter((nav) => !(nav.hideForTempAgency && this.isTempAgencyMode));
    },
    noChildren() {
      return this.companyStore.noChildren;
    },
    // SP-14862 — `GET /v3/customers/{id}/stats` is scoped by the id in its URL and
    // ignores the `X-Instead-Of-Customer` header, so `customerKpi()` asks for the
    // selected account: a child when a team is active, the account owner on
    // "Tous les comptes" (the backend then aggregates its hierarchy).
    nbStudentsToRate() {
      return this.customerKpiStore.nbStudentsToRate;
    },
    nbStudentsToValidate() {
      return this.customerKpiStore.nbStudentsToValidate;
    },
    nbQuoteToValidate() {
      return this.customerKpiStore.nbQuoteToValidate;
    },
    nbContractsToSign() {
      return this.customerKpiStore.nbContractsToSign;
    },
  },
  watch: {
    $route() {
      document.body.classList.remove('sidebar-mobile-show');
      this.route = this.$route;
      this.customerKpi();
      this.$forceUpdate();
    },
    // SP-14862 — the counters are scoped to the selected account, so they have to be
    // refetched whenever the selection changes. `currentCompany` covers every path:
    // the initial `setDefault()`, a team switch (`change()`) and "Tous les comptes"
    // (`reset()`) — watching `accountStore.company` on top of it only duplicated the
    // request, both being written in the same tick by `accountStore.store()`.
    'companyStore.currentCompany': {
      handler() {
        this.customerKpi();
      },
    },
  },
  mounted() {
    this.route = this.$route;
    this.customerKpi();
  },
  methods: {
    handleBeforeNavigation() {
      this.customerKpi();
    },
    customerKpi() {
      const selectedCompany = this.companyStore.currentCompany;

      this.customerKpiStore.refreshAccountsKpi();

      if (selectedCompany) {
        DataService.customerKpi(selectedCompany.id)
          .then((data) => {
            // A late response must not restore a counter from the previous account.
            if (this.companyStore.currentCompany !== selectedCompany) return;
            this.customerKpiStore.countStudentsToRate(data.studentsKpi.nbStudentsToRate);
            this.customerKpiStore.countStudentsToValidate(data.studentsKpi.nbStudentsToValidate);
            this.customerKpiStore.countQuoteToValidate(data.nbQuoteToValidate);
            // SP-13434 — le compteur des contrats « à signer » sera fourni par l'API en temps 2 (SP-13455).
            // Dispatch défensif : tant que le champ n'est pas renvoyé, le badge reste masqué (0).
            if (data.nbContractsToSign !== undefined) {
              this.customerKpiStore.countContractsToSign(data.nbContractsToSign);
            }
          })
          .catch((error) => {
            // SP-14582 — badges are not blocking: keep the previous counters instead of
            // letting the rejection bubble up as an unhandled rejection (Sentry noise when
            // the request is aborted by a navigation).
            window.console.warn('Sidebar: customer KPI request failed', error && error.message);
          });
      }
    },
    showVideoPopup(link, videoName, padding) {
      if (link && link.length) {
        this.videoPopupStore.open({
          link,
          videoName,
          params: { arcadePadding: padding },
          close_name: videoName,
        });
      }
    },
    handleClick(event) {
      if (this.accountStore.arcadeLinks) {
        this.checkIfVideoPopup(event);
      }
      this.mxTrack(event);
      this.$nextTick(() => {
        document.body.classList.remove('sidebar-mobile-show');
      });
    },
    checkIfVideoPopup(event) {
      if (this.accountStore.arcadeLinks) {
        switch (event) {
          case '/job':
            this.showVideoPopup(this.accountStore.arcadeLinks.url_arcade_monitoring_staffing, 'monitoring_staffing', 'calc(48.68055555555556% + 41px)');
            break;
          case '/students':
            this.showVideoPopup(this.accountStore.arcadeLinks.url_arcade_evaluating_students, 'evaluating_students', null);
            break;
          case '/invoice':
            this.showVideoPopup(this.accountStore.arcadeLinks.url_arcade_billing, 'billing', null);
            break;
          case '/validations':
            if (this.nbStudentsToValidate) {
              this.showVideoPopup(this.accountStore.arcadeLinks.url_arcade_hours_validation, 'hours_validation', null);
            }
            break;
          case '/checkout':
            break;
          default:
            return false;
        }
      }
      return false;
    },
    mxTrack(event) {
      switch (event) {
        case 'job':
          this.$mixpanel.track('Side Bar Job Clicked');
          break;
        case 'student':
          this.$mixpanel.track('Side Bar Students Clicked');
          break;
        case 'invoice':
          this.$mixpanel.track('Side Bar Billing Clicked');
          break;
        case 'data':
          this.$mixpanel.track('Side Bar Reporting Clicked');
          break;
        case 'checkout':
          this.$mixpanel.track('Side Bar Order Clicked');
          this.cartStore.setFrom('Buton Order');
          break;
        default:
          return false;
      }
      return false;
    },
    sidebarHover(event) {
      this.$nextTick(() => {
        if (event.target.childNodes[0] && event.target.childNodes[0].src) {
          event.target.childNodes[0].src = event.target.childNodes[0].src.replace('inactive', 'active');
        }
      });
    },
    sidebarRemoveHover(event) {
      this.$nextTick(() => {
        if (!event.target.classList.contains('active') && event.target.childNodes[0]) {
          event.target.childNodes[0].src = event.target.childNodes[0].src.replace('active', 'inactive');
        }
      });
    },
  },
};
</script>

<style lang="css">
.nav-link {
  cursor: pointer;
}
</style>
